var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import styled from 'styled-components';
import { EGamePhase, } from '../../../../types';
import { setMatchDay, setMatchNight } from '../../../../api';
import { selectMatchState, setMatchState } from '../../../../store/match';
import { useAppDispatch, useAppSelector, useQuery } from '../../../../hooks';
import { useErrorHandler } from '../../../../hooks/useErrorHandler';
import { DeskPool } from '../../DeskPool';
import { Portal } from '../../../atoms/Portal/Portal';
import { EventItem } from '../../../atoms/EventItem';
// Fixed side panel that sits to the left of DeskFooterComponent (width 271px)
const SidePanel = styled.div `
  position: fixed;
  top: 0;
  right: 271px;
  bottom: 0;
  z-index: 99998;

  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 405px;
  padding: 60px 22px;

  background-color: rgba(23, 28, 31, 0.97);
  border-left: 1px solid rgba(255, 255, 255, 0.08);

  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
const Title = styled.h2 `
  margin: 0 0 15px;

  font-family: Bowler;
  font-size: 23px;
  line-height: 25px;
  color: #fff;
`;
const EventList = styled.div `
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
const NoEventsText = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;

  font-family: Bowler;
  font-size: 20px;
  color: rgba(200, 200, 200, 0.7);
  text-align: center;
`;
export function ShowPhaseEvents({ useCase }) {
    const { param: matchId } = useQuery('matchId');
    const { errorHandler } = useErrorHandler(matchId);
    const dispatch = useAppDispatch();
    const matchState = useAppSelector(selectMatchState);
    const [isLoading, setIsLoading] = useState(false);
    const events = useMemo(() => (matchState === null || matchState === void 0 ? void 0 : matchState.state).events || [], [matchState]);
    const matchStateId = (matchState === null || matchState === void 0 ? void 0 : matchState.id) || '';
    const incrementIndex = () => __awaiter(this, void 0, void 0, function* () {
        setIsLoading(true);
        try {
            const result = useCase === EGamePhase.DAY ? yield setMatchNight(matchStateId) : yield setMatchDay(matchStateId);
            dispatch(setMatchState(result));
        }
        catch (err) {
            errorHandler(err);
        }
        finally {
            setIsLoading(false);
        }
    });
    const buttonText = useCase === EGamePhase.DAY ? 'Город засыпает' : 'Начать голосование';
    const onPlayerClickAction = null;
    const gameButtonState = {
        text: isLoading ? 'Выполняется...' : buttonText,
        visible: true,
        onClick: incrementIndex,
        disabled: isLoading,
    };
    return (_jsxs(_Fragment, { children: [_jsx(DeskPool, { onPlayerClickAction: onPlayerClickAction, gameButtonState: gameButtonState }), _jsx(Portal, { children: _jsxs(SidePanel, { children: [_jsx(Title, { children: "\u0418\u0442\u043E\u0433\u0438" }), events.length > 0 ? (_jsx(EventList, { children: events.map((event, i) => (_jsx(EventItem, { event: event }, i))) })) : (_jsx(NoEventsText, { children: "\u0421\u043C\u0435\u0440\u0442\u0435\u0439 \u043D\u0435\u0442" }))] }) })] }));
}
